import { useEffect, useState } from 'react';
import {
    getLinkToBattlecards,
    initialMatrixFilter,
    MATRIX_COMPONENTS,
    PRIORITIES_MATRIX_FILTERS,
} from 'components/widgets/PrioritiesMatrix/prioritiesMatrixComponent.utils';
import useEventWithDimensions from 'hooks/useEventWithDimensions';
import useUserHook from 'hooks/useUserHook';

export const usePrioritiesMatrixLogic = ({
    widgetId,
    setMatrixCardCategoryId,
    isAssignedToMeFilter,
    ui,
    api,
    setMatrixFilter,
    matrixFilter,
}) => {
    const { email } = useUserHook();
    const [filtersTitle, setFiltersTitle] = useState<string>('Urgent');
    const { sendEventWithDimensions } = useEventWithDimensions();
    const urgentFilter = PRIORITIES_MATRIX_FILTERS.find((filter) => filter.value === matrixFilter);

    const setFilterTitle = (componentType: string) => {
        const title = MATRIX_COMPONENTS[componentType].urgent ? 'Urgent' : ' Not Urgent';
        setFiltersTitle(title);
    };

    const handleFilterClick = (filter: ISelectOption<string>) => {
        const value = filter.value;
        sendEventWithDimensions({
            category: 'Priorities Matrix',
            action: 'Range Selection',
            label: value,
        });
        setMatrixFilter(value);
    };

    const fetchCardsData = ({ itemId }) => {
        setMatrixCardCategoryId(itemId);
    };

    const getAssignedToMeQueryFilter = () => {
        if (isAssignedToMeFilter) {
            const assignedId = api.cards?.data?.find((item) => item.assignee.userName === email);
            return assignedId ? assignedId?.assignee.userName : null;
        }

        return null;
    };

    const linkToProjectActivities = getLinkToBattlecards({
        ui,
        getAssignedToMeQueryFilter,
    });

    useEffect(() => {
        if (!matrixFilter && !widgetId) {
            setMatrixFilter(initialMatrixFilter);
        }
    }, [matrixFilter, widgetId]);

    return {
        setFilterTitle,
        filtersTitle,
        handleFilterClick,
        urgentFilter,
        linkToProjectActivities,
        fetchCardsData,
    };
};
